import axiosInstance from "../variables/api/axiosInstance";

export const searchProduction = async (searchValue) => {
    return await axiosInstance.get(`/api/contrat/search`, {
        params: {
            page: 0,
            size: 10,
            search: searchValue,
        },
    });
}

// Contrats VALIDES d'une immatriculation, TOUTES compagnies confondues (indicatif : signale au
// rédacteur qu'une moto a un contrat valide dans une autre compagnie).
export const getContratsAutresCompagnies = async (immatriculation) => {
    return await axiosInstance.get(`/api/sinistre/engin-autres-compagnies`, {
        params: { immatriculation },
    });
}

export const searchActiveProduction = async (searchValue, size = 10) => {
    return await axiosInstance.get(`/api/contrat`, {
        params: {
            page: 0,
            size,
            search: searchValue,
            avenant: "A"
        },
    });
}

// Recherche AFFINÉE de contrats ACTIFS, portée « compagnie connectée » (comme la barre
// de recherche de la navbar /production : /api/contrat/search force isSiege=true), avec
// le même moteur de recherche immatriculation (normalisé, multi-engins). Filtre avenant
// 'A' = exclut résiliés/suspendus. Utilisée par la déclaration de sinistre.
export const searchActiveProductionRefined = async (searchValue, size = 30, compagnie = null) => {
    return await axiosInstance.get(`/api/contrat/search`, {
        params: {
            page: 0,
            size,
            search: searchValue,
            avenant: "A",
            // Restreint la recherche à une compagnie/organisme côté SERVEUR (ex. le Pool ne
            // voit que ses contrats) → plus rapide et n'écarte plus les VT par troncature.
            ...(compagnie ? { compagnie } : {}),
        },
    });
}

export const searchSinistre = async (searchValue) => {
    return await axiosInstance.get(`/api/sinistre/sql`, {
        params: {
            page: 0,
            size: 10,
            search: searchValue,
        },
    });
}

export const searchUtilisateur = async (searchValue) => {
    return await axiosInstance.get(`/api/utilisateur`, {
        params: {
            page: 0,
            size: 10,
            search: searchValue,
            // Résultats par ordre alphabétique (tri global côté serveur)
            sortBy: "nom",
            sortDir: "asc",
            sortedName: true,
        },
    });
}

export const searchIntermediaire = async (searchValue) => {
    return await axiosInstance.get(`/api/intermediaire/page`, {
        params: {
            page: 0,
            size: 10,
            search: searchValue,
            // Résultats par ordre alphabétique (tri global côté serveur)
            sortBy: "nom",
            sortDir: "asc",
        },
    });
}

export const searchAgenceByCompagnie = async (searchValue, codeCompagnie) => {
    return await axiosInstance.get(`/api/agence`, {
        params: {
            page: 0,
            size: 10,
            search: searchValue,
            organisme: codeCompagnie,
        },
    });
}

export const searchProfil = async (searchValue) => {
    return await axiosInstance.get(`/api/profil`, {
        params: {
            page: 0,
            size: 10,
            search: searchValue,
        },
    });
}

export const searchLotAttestation = async (searchValue) => {
    return await axiosInstance.get(`/api/lot-attestation/search`, {
        params: {
            search: parseInt(searchValue),
        },
    });
}

export const searchDecaissement = async (searchValue) => {
    return await axiosInstance.get(`/api/decaissement/search`, {
        params: {
            search: searchValue,
        },
    });
}

export const searchRoute = async (searchValue) => {
    return await axiosInstance.get(`/api/route`, {
        params: {
            search: searchValue,
        },
    });
}

export const searchCompte = async (searchValue) => {
    return await axiosInstance.get(`/api/compte-comptable`, {
        params: {
            search: parseInt(searchValue) || null,
        },
    });
}

export const searchAssure = async (searchValue) => {
    return await axiosInstance.get(`/api/personne/clients`, {
        params: {
            page: 0,
            size: 10,
            search: searchValue,
        },
    });
}













